import randomstring from 'randomstring';

const state = {
    type: 'segment',
    model: null,
    op: 'and',
    rules: [],
}

const getters = {

    type: state => {
        return state.type;
    },

    model: state => {
        return state.model;
    },

    op: state => {
        return state.op;
    },

    rules: state => {
        return state.rules;
    },

}

const mutations = {

    setType(state, type) {
        state.type = type;
    },

    setModel(state, model) {
        state.model = model;
    },

    setOp(state, op) {
        state.op = op;
    },

    setRules(state, rules) {
        state.rules = [];
        rules.forEach(group => {
            group.id = randomstring.generate(30);
            group.rules.forEach(rule => {
                rule.id = randomstring.generate(30);
            });
            state.rules.push(group);
        });
    },

    addRuleGroup(state, op = 'and') {
        state.rules.push({
            id: randomstring.generate(30),
            op: op,
            rules: [{ id: randomstring.generate(30) }],
        });
    },

    updateRuleGroup(state, params) {
        let group = state.rules.find(i => i.id === params.id);
        group.op = params.op;
    },

    addRule(state, id) {
        let group = state.rules.find(i => i.id === id);
        group.rules.push({ id: randomstring.generate(30) });
    },

    updateRule(state, params) {
        state.rules.forEach(group => {
            group.rules.forEach((rule, ruleIndex) => {
                if (rule.id === params.id) {
                    group.rules[ruleIndex] = params;
                }
            });
        });
    },

    removeRule(state, id) {
        state.rules.forEach((group, groupIndex) => {
            group.rules.forEach((rule, ruleIndex) => {
                if (rule.id === id) {
                    group.rules.splice(ruleIndex, 1);
                    if (group.rules.length === 0) {
                        state.rules.splice(groupIndex, 1);
                    }
                }
            });
        });
    },

    sortRules(state, params) {
        let group = state.rules.find(i => i.id === params.id);
        group.rules = params.rules;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}